export default function getIdFromUrl(location) {
  if (!location) {
    return null;
  }

  const [, idString] = location.pathname.split('/');

  return idString !== 'admin' ? idString : null;
}
